/**
 * Cross-screen glue (D-151 Batch 3). Two tiny in-memory stores in the openMasterDataTab tradition:
 *
 * 1. The CATEGORY SCOPE — one consistent category selection shared by the category screens. It holds
 *    a category NAME from the live register; screens with a live category selector write it on change
 *    and adopt it on mount. Deliberately in-memory only (resets on reload; no storage surface).
 *
 * 2. The one-shot ROUTE CONTEXT — a "so what" handoff payload (supplier and/or category) set right
 *    before onNavigate and consumed exactly once by the destination screen, so a scorecard row can
 *    preselect the review form, a supplier row can preselect the template allocation, and so on.
 *    Consuming clears it, so stale context never leaks into a later visit.
 */
let categoryScope = null;
export function setCategoryScope(name) {
    categoryScope = name;
}
export function getCategoryScope() {
    return categoryScope;
}
let pendingContext = null;
export function setRouteContext(ctx) {
    pendingContext = ctx;
}
/** One-shot: the first consumer takes it and it is gone. */
export function consumeRouteContext() {
    const c = pendingContext;
    pendingContext = null;
    return c;
}
//# sourceMappingURL=routeScope.js.map